module.exports = __webpack_public_path__ + "static/img/xiaohongshu.c57ca67.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/zbqfBrand/xiaohongshu.png
// module id = vbzU
// module chunks = 0